import React from 'react'

import RadioOption from '../../RadioOption/RadioOption'
import Error from './Error/Error'


const ErrorRadioButton = ({ name, activeOption, activeOptionLink, label, isActive, dataTestId, onEdit, ariaLabelledBy }) => (
  <RadioOption
    name={name}
    activeOption={activeOption}
    activeOptionLink={activeOptionLink}
    label={label}
    isActive={isActive}
    hasError
    dataTestId={dataTestId}
    ariaLabelledBy={ariaLabelledBy}
  >
    <Error onEdit={onEdit} />
  </RadioOption>
)

export default ErrorRadioButton
